import { Divider, Table, TableBody } from "@mui/material";
import { useState, useEffect } from "react";
import { BudgetTableHeader } from "./BudgetTableHeader";
import { BudgetRow as BudgetRowComponent } from "./BudgetRow";
import { FinancialSummary } from "./FinancialSummary";
import { BudgetRow } from "./types";

interface BudgetTableProps {
  rows: BudgetRow[];
  months: string[];
  changedFields: Set<string>;
  onAmountChange: (rowId: string, month: string, value: string) => void;
  onDeleteRow: (rowId: string) => void;
  onClearRow: (rowId: string) => void;
}

export const BudgetTable = ({
  rows,
  months,
  changedFields,
  onAmountChange,
  onDeleteRow,
  onClearRow,
}: BudgetTableProps) => {
  const [collapsedGroups, setCollapsedGroups] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    const collapsedCount = Object.keys(collapsedGroups).length;
    if (collapsedCount === 0 && rows.length > 0) {
      // this is the first load
      const uniqueGroupKeys = new Set(rows.filter(r => r.groupKey).map(r => r.groupKey));
      const initialCollapsedGroups = Array.from(uniqueGroupKeys).reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {} as { [key: string]: boolean });
      setCollapsedGroups(initialCollapsedGroups);
    }
  }, [rows, collapsedGroups]);

  const handleToggleGroup = (groupKey: string) => {
    setCollapsedGroups(prev => ({
      ...prev,
      [groupKey]: !prev[groupKey]
    }));
  };

  return (
    <div className="overflow-auto flex-1">
      <div className="relative w-full">
        <div className="overflow-x-auto">
          <Table>
            <BudgetTableHeader
              months={months}
            />
            <TableBody>
              {rows.map((row) => (
                <BudgetRowComponent
                  key={row.id}
                  row={row}
                  months={months}
                  changedFields={changedFields}
                  onAmountChange={onAmountChange}
                  onDeleteRow={onDeleteRow}
                  onClearRow={onClearRow}
                  isGroupCollapsed={collapsedGroups}
                  onToggleGroup={handleToggleGroup}
                />
              ))}
            </TableBody>
            <FinancialSummary
              rows={rows}
              months={months}
            />
          </Table>
        </div>
      </div>
    </div>
  );
};